import { render, staticRenderFns } from "./OtpHeader.vue?vue&type=template&id=d4b50310&scoped=true&"
import script from "./OtpHeader.vue?vue&type=script&lang=js&"
export * from "./OtpHeader.vue?vue&type=script&lang=js&"
import style0 from "./OtpHeader.vue?vue&type=style&index=0&id=d4b50310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b50310",
  null
  
)

export default component.exports